export const toServerEnv = (envString: string): ServerEnv => {
  switch (envString) {
    case 'local':
    case 'alpha':
    case 'demo':
    case 'production':
      return envString;
    default:
      return 'production';
  }
};
